"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCreateOrderItemsFromCart = void 0;
const mapCreateOrderItemsFromCart = (cartItems) => cartItems.map((cartItem) => ({
    sku: cartItem.id,
    quantity: cartItem.quantity,
}));
exports.mapCreateOrderItemsFromCart = mapCreateOrderItemsFromCart;
